import { Action } from '@ngrx/store';
import { GetAccountsResponse, BootstrapAccountPayload } from './interfaces';

export enum MAActionType {
  GetAccountFlowStatistics = '[MA] Get Account Statistics',
  GetAccountFlowStatisticsSuccess = '[MA] Get Account Statistics Success',
  GetAccountFlowStatisticsFail = '[MA] Get Account Statistics Fail',
  BootStrapAccount = '[MA] Bootstrap Account',
  BootStrapAccountSuccess = '[MA] Bootstrap Account Success',
  BootStrapAccountFail = '[MA] Bootstrap Account Fail',
  GetCreatedFlowsByMonths = '[MA Statistics] Get Created Flows By Months',
  GetCreatedFlowsByMonthsSuccess = '[MA Statistics] Get Created Flows By Months Success',
  GetCreatedFlowsByMonthsFail = '[MA Statistics] Get Created Flows By Months Fail',
  GetCreatedFlowsByDays = '[MA Statistics] Get Created Flows By Days',
  GetCreatedFlowsByDaysSuccess = '[MA Statistics] Get Created Flows By Days Success',
  GetCreatedFlowsByDaysFail = '[MA Statistics] Get Created Flows By Days Fail',
  GetActiveProfileInFlows = '[MA Statistics] Get Active Profiles In Flows',
  GetActiveProfileInFlowsSuccess = '[MA Statistics] Get Active Profiles In Flows Success',
  GetActiveProfileInFlowsFail = '[MA Statistics] Get Active Profiles In Flows Fail',
  GetActiveFlows = '[MA Statistics] Get Active Flows',
  GetActiveFlowsSuccess = '[MA Statistics] Get Active Flows Success',
  GetActiveFlowsFail = '[MA Statistics] Get Active Flows Fail',
}

export class GetCreatedFlowsByMonthsAction implements Action {
  readonly type = MAActionType.GetCreatedFlowsByMonths;
  constructor(public payload: void) {}
}

export class GetCreatedFlowsByMonthsSuccessAction implements Action {
  readonly type = MAActionType.GetCreatedFlowsByMonthsSuccess;
  constructor(public payload: any) {}
}

export class GetCreatedFlowsByMonthsFailAction implements Action {
  readonly type = MAActionType.GetCreatedFlowsByMonthsFail;
  constructor(public payload: void) {}
}

export class GetCreatedFlowsByDaysAction implements Action {
  readonly type = MAActionType.GetCreatedFlowsByDays;
  constructor(public payload: void) {}
}

export class GetCreatedFlowsByDaysSuccessAction implements Action {
  readonly type = MAActionType.GetCreatedFlowsByDaysSuccess;
  constructor(public payload: any) {}
}

export class GetCreatedFlowsByDaysFailAction implements Action {
  readonly type = MAActionType.GetCreatedFlowsByDaysFail;
  constructor(public payload: void) {}
}

export class GetActiveProfileInFlowsAction implements Action {
  readonly type = MAActionType.GetActiveProfileInFlows;
  constructor(public payload: void) {}
}

export class GetActiveProfileInFlowsSuccessAction implements Action {
  readonly type = MAActionType.GetActiveProfileInFlowsSuccess;
  constructor(public payload: any) {}
}

export class GetActiveProfileInFlowsFailAction implements Action {
  readonly type = MAActionType.GetActiveProfileInFlowsFail;
  constructor(public payload: void) {}
}

export class GetAccountFlowStatisticsAction implements Action {
  readonly type = MAActionType.GetAccountFlowStatistics;
  constructor(public payload: void) {}
}

export class GetAccountFlowStatisticsSuccessAction implements Action {
  readonly type = MAActionType.GetAccountFlowStatisticsSuccess;
  constructor(public payload: GetAccountsResponse) {}
}

export class GetAccountFlowStatisticsFailAction implements Action {
  readonly type = MAActionType.GetAccountFlowStatisticsFail;
  constructor(public payload: void) {}
}

export class BootStrapAccountAction implements Action {
  readonly type = MAActionType.BootStrapAccount;
  constructor(public payload: BootstrapAccountPayload) {}
}

export class BootStrapAccountSuccessAction implements Action {
  readonly type = MAActionType.BootStrapAccountSuccess;
  constructor(public payload: string) {}
}

export class BootStrapAccountFailAction implements Action {
  readonly type = MAActionType.BootStrapAccountFail;
  constructor(public payload: void) {}
}

export class GetActiveFlowsAction implements Action {
  readonly type = MAActionType.GetActiveFlows;
  constructor(public payload: number) {}
}

export class GetActiveFlowsSuccessAction implements Action {
  readonly type = MAActionType.GetActiveFlowsSuccess;
  constructor(public payload: any) {}
}

export class GetActiveFlowsFailAction implements Action {
  readonly type = MAActionType.GetActiveFlowsFail;
  constructor(public payload: void) {}
}

export type MAActionTypes =
  | GetCreatedFlowsByMonthsAction
  | GetCreatedFlowsByMonthsSuccessAction
  | GetCreatedFlowsByMonthsFailAction
  | GetCreatedFlowsByDaysAction
  | GetCreatedFlowsByDaysSuccessAction
  | GetCreatedFlowsByDaysFailAction
  | GetActiveProfileInFlowsAction
  | GetActiveProfileInFlowsSuccessAction
  | GetActiveProfileInFlowsFailAction
  | GetAccountFlowStatisticsAction
  | GetAccountFlowStatisticsSuccessAction
  | GetAccountFlowStatisticsFailAction
  | BootStrapAccountAction
  | BootStrapAccountSuccessAction
  | BootStrapAccountFailAction
  | GetActiveFlowsAction
  | GetActiveFlowsSuccessAction
  | GetActiveFlowsFailAction;
